// Stamped once per page load, not per request: every load of the page fetches
// the colour images fresh, but within one session the same URL keeps coming
// back, so the browser's in-memory copy and loadSide's "reuse the background
// that is already up" check both still work.
const CACHE_BUST = Date.now();

// URL of a product colour image (front/back/... path from the colour record),
// with ?v=<timestamp> so a replaced image on the server is never served stale.
export default function colorImageUrl(siteUrl, path) {
	const url = siteUrl + 'wp-content/uploads/' + path;
	return url + (url.includes('?') ? '&' : '?') + 'v=' + CACHE_BUST;
}
